import { acceptHMRUpdate, defineStore, storeToRefs } from 'pinia'
import { computed, ref } from 'vue'

import { bookingsApi } from '@/api/client'

import { useBookingStore } from './booking'

export const useConfigStore = defineStore('config', () => {
  const config = ref({
    dinersLimit: null,
    extraText: '',
    warranty: {
      type: 'NONE',
      amount: 0
    },
    cancellation: {
      time: 1,
      unit: 'days'
    }
  })

  const bookingStore = useBookingStore()
  const { bookingId } = storeToRefs(bookingStore)

  const getConfig = computed(() => config.value)

  const hasWarranty = computed(() => {
    return config.value.warranty.type !== 'NONE' && !bookingId.value
  })

  async function getLocationConfig() {
    const response = await bookingsApi.getConfig()
    config.value = response
  }

  return {
    config,
    getConfig,
    hasWarranty,
    getLocationConfig
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useConfigStore, import.meta.hot))
}
